import { createSelectorsFromModel } from '@/helpers/redux';

const model = {
    accommodationDetails: null,
    roomTypeList: [],
    loading: false,
    error: null,

    // offers
    offerDetails: null,
    offerList: [],
    submitting: false,
    id: null,
    messageSuccess: '',
    messageError: null,

    // change form visibility
    visibleForm: false,

    roomList: localStorage.getItem('accommodationRooms') ? JSON.parse(localStorage.getItem('accommodationRooms')) : [],
    filterData:
        localStorage.getItem('accommodationRoomsFilter')
            ? JSON.parse(localStorage.getItem('accommodationRoomsFilter'))
            : {
                date_start: null,
                date_end: null,
                adults: 2,
                children: 0,
                ages: [],
            },
    sendRequest: false,
    fetchingLoading: true,
    fetchingError: null,
    isLoadingMore: false,
    isLoadingMoreError: null,
    hasMore: false,
};

export const selectors = createSelectorsFromModel(
    (state) => state.accommodation.hotel.view,
    model,
);

export default model;
